import { Subject } from "rxjs";
import { renderApiServer } from "../message/APIProxy.render.server";

export const imageBase64Sub = new Subject<string>();

renderApiServer.render.updateScreenImage.onRequest((imageInBase64) => {
  console.log("#renderApiServer.render.updateScreenImage.onRequest");
  imageBase64Sub.next(imageInBase64);
});
